import apiFetch from '../../apiFetch'

export default function (stockDossierId, stockdossier, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/stock/${stockDossierId}`, method: 'PUT', body: stockdossier, token: token, lastAccessDate })
}
